export default "__VITE_ASSET__0c74885b__"